//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

export const coachingProfileRoutes = [
  {
    path: i18n.global.t('routes.coachingProfile.profile'),
    name: Routes.COACHING_PROFILE,
    component: () => import('@/components/coachingProfile/CoachingProfile.vue'),
    meta: {
      title: i18n.global.t('titles.coachingProfile.profile'),
      active: 'coachingProfile',
    },
  },
  {
    // Clean layout, authenticated — the onboarding gate (App.vue) sends new
    // coaches here until they have created their profile.
    path: i18n.global.t('routes.coachingProfile.onboarding'),
    name: Routes.COACHING_PROFILE_ONBOARDING,
    component: () => import('@/components/coachingProfile/CoachingProfileOnboarding.vue'),
    meta: {
      layout: 'clean',
      title: i18n.global.t('titles.coachingProfile.onboarding'),
    },
  },
  {
    path: i18n.global.t('routes.coachingProfile.search'),
    name: Routes.COACHING_PROFILE_SEARCH,
    component: () => import('@/components/coachingProfile/CoachingProfileSearch.vue'),
    meta: {
      title: i18n.global.t('titles.coachingProfile.search'),
      active: 'coachingProfileSearch',
    },
  },
];
